import { ModalNamesEnum } from '@shared/enums/modalNames.enum';
import { ProfileViewDataEnum } from '@shared/enums/profileViewData.enum';
import modalObserver from '@shared/utils/observers/modalObserver';
import { setViewDataItem } from '@store/Profile/profile.actions';

import type { AppDispatch } from '@store/store';
import type { TFunction } from 'i18next';
import type { NavigateFunction } from 'react-router';

type PropsType = {
  dispatch: AppDispatch;
  navigate: NavigateFunction;
  t: TFunction;
  nextBill: string;
};
export const renderUpgradePlanInfoModal = ({ dispatch, t, nextBill }: PropsType) => {
  modalObserver.addModal(ModalNamesEnum.alertModal, {
    props: {
      rightBtnProps: {
        label: t('general.buttons.great'),
        isShow: true,
        onClick: () => {
          dispatch?.(setViewDataItem({ entity: ProfileViewDataEnum.is_view_plan_logic_change }));
          modalObserver.removeModal(ModalNamesEnum.alertModal);
        },
      },
      middleBtnProps: {
        isShow: false,
      },
      modalContent: {
        header: t('general.modals.upgradePlanInfoModal.header'),
        subtitle: t('general.modals.upgradePlanInfoModal.subtitle', { date: nextBill }),
        title: t('general.modals.upgradePlanInfoModal.title'),
        variantIcon: 'confetti',
        onClose: () => {
          dispatch?.(setViewDataItem({ entity: ProfileViewDataEnum.is_view_plan_logic_change }));
          modalObserver.removeModal(ModalNamesEnum.alertModal);
        },
      },
    },
  });
};
